import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const DataContext = createContext({ settings: null, zones: [], services: [], neighborhoods: [], faqs: [], categories: [], brands: [] });

export function DataProvider({ children }) {
  const [data, setData] = useState({ settings: null, zones: [], services: [], neighborhoods: [], faqs: [], categories: [] });

  useEffect(() => {
    Promise.all([
      api.get("/content"),
      api.get("/services"),
      api.get("/neighborhoods"),
      api.get("/faqs"),
      api.get("/categories"),
      api.get("/brands"),
    ])
      .then(([content, services, neighborhoods, faqs, categories, brands]) =>
        setData({
          settings: content.data.settings,
          zones: content.data.zones,
          services: services.data,
          neighborhoods: neighborhoods.data,
          faqs: faqs.data,
          categories: categories.data,
          brands: brands.data,
        })
      )
      .catch(() => {});
  }, []);

  return <DataContext.Provider value={data}>{children}</DataContext.Provider>;
}

export const useData = () => useContext(DataContext);
